<app-header></app-header>
<router-outlet></router-outlet>
<app-global-spinner></app-global-spinner>